import { useIsSmallDesktop } from '@src/utilities/screenResizeUtility';
import styles from './ImageCard.module.scss';

interface ImageProps {
  milestoneName?: string;
}

const determineImageType = (milestoneName: string) => {
  if (milestoneName.startsWith('transition') || milestoneName.startsWith('applicant')) {
    return 'applicationStateImage';
  } else if (milestoneName.startsWith('learner')) {
    return 'learnerStateImage';
  } else if (milestoneName.startsWith('completer')) {
    return 'completerStateImage';
  } else {
    return 'memberStateImage';
  }
};
const imgDomain = 'https://guild.imgix.net/student-home/learning-lifecycles';

const ImageCard: React.FC<ImageProps> = ({ milestoneName = '' }) => {
  const type = determineImageType(milestoneName);
  const isSmallDesktop = useIsSmallDesktop();

  let imgSrcLeft;
  let imgSrcRight;
  let testId;
  switch (type) {
    case 'memberStateImage':
      imgSrcLeft = `${imgDomain}/member-state-left-3.jpg`;
      imgSrcRight = `${imgDomain}/member-state-right-2.jpg`;
      testId = 'member-state-images';
      break;
    case 'applicationStateImage':
      imgSrcLeft = `${imgDomain}/application-state-left-4.jpg`;
      imgSrcRight = `${imgDomain}/application-state-right-2.jpg`;
      testId = 'application-state-images';
      break;
    case 'learnerStateImage':
      imgSrcLeft = `${imgDomain}/learner-state-left-2.jpg`;
      imgSrcRight = `${imgDomain}/learner-state-right-2.jpg`;
      testId = 'learner-state-images';
      break;
    case 'completerStateImage':
      imgSrcLeft = `${imgDomain}/completer-state-left.jpg`;
      imgSrcRight = `${imgDomain}/completer-state-right.jpg`;
      testId = 'completer-state-images';
      break;
  }
  return (
    <div className={styles.imageContainer} data-testid={testId}>
      <img alt='' src={imgSrcLeft} />
      {!isSmallDesktop && <img alt='' src={imgSrcRight} />}
    </div>
  );
};

export default ImageCard;
